/**
 * 考试的公共页面
 */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Row, Col, Input, Pagination, Result, message } from 'antd';
import { ClockCircleOutlined } from "@ant-design/icons";
import { getExternalActist } from "../../apis/public";
import MenuComp from '../../College/layout/Menu';
import "./index.less";

const { Search } = Input;

interface IProps extends RouteComponentProps {}
interface IState {
  limit: number;
  page: number;
  totalCount: number;
  title: string;
  listData: any[];
  showSearchModal: boolean;
}


class ExamIndex extends Component<IProps, IState> {
  state: IState = {
    limit: 10,
    page: 1,
    totalCount: 10,
    title: "", // 考试标题
    listData: [],
    showSearchModal: false
  }

  componentDidMount() {
    this.initialData();
  }
  // 获取内部考考试数据
  initialData = () => {
    const { limit, page, title } = this.state;
    const params = {
      limit,
      page,
      title
    };
    getExternalActist(params).then((res: any) => {
      console.log(res);
      if (res && res.code === 0) {
        const { data = [], total_count } = res.data;
        this.setState({
          listData: data ? data : [],
          totalCount: total_count
        })
      } else {
        res && message.error(res.msg);
      }
    }) 
  }
  // 改变页码
  changePage = (current: number) => {
    this.setState({
      page: current
    }, () => {
      this.initialData();
    })
  }
  // 页面显示数量改变
  onShowSizeChange = (current: number, pageSize: number) => {
    this.setState({
      // page: current,
      limit: pageSize
    })
  }
  // 搜索
  onSearch = (value: string) => {
    this.setState({
      title: value
    }, () => {
      this.initialData();
    })
  }
  // 详情
  goDetail = (data: any) => {
    this.props.history.push(`/activity/${data.id}`);
  }
  // 查询证书
  changeSearchModal = () => {
    this.setState({
      showSearchModal: !this.state.showSearchModal
    })
  }
  render() {
    const { limit, page, totalCount, listData } = this.state;
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    return (
      <div className="public_exam">
        {/* <div className="public_nav">
          <div className="nav">
            <div className="logo">
              <img src={Logo} alt=""/>
            </div>
          </div>
        </div> */}
        <MenuComp userinfo={userinfo} />
        <div className="public_inner" style={{marginTop: 20}}>
          <div className="inner" style={{backgroundColor: '#FFF'}}>
            <Row justify="space-between" style={{marginBottom: 40}}>
              <Col>
                <div className="inner_title">
                  <p>活动中心</p>
                  <div className="inner_title_line"></div>
                </div>
              </Col>
              <Col style={{display: 'flex'}}>
                <Search allowClear placeholder="请输入关键字" onSearch={this.onSearch} enterButton={<span>搜索</span>} />
              </Col>
            </Row>
            <Row>
              <ul className="ullist">
                {
                  listData.length > 0 ? listData.map((item: any) => {
                    return (
                      <li key={item.id} onClick={() => this.goDetail(item)}>
                        <div className="course_item">
                          <img src={item.file_url} alt=""/>
                          <div className="text">
                            <div className="title">{item.title}</div>
                            <div className="line"></div>
                            <div className="cour">
                              <div className="left" style={{color: '#53B880'}}><ClockCircleOutlined /> 活动进行中</div>
                              <div className="right"> </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    )
                  }) : <Result title="暂无相关活动" />
                }
              </ul>
            </Row>
            {/* <ul className="ullist">
              {
                listData.length > 0 ? listData.map(item => {
                  return (
                    <li key={item.id}>
                      <div className="left">
                        <div className="img">
                          <img src={item.file_url} alt=""/>
                        </div>
                        <div className="del">
                          <div>
                            <div className="title">{item.title}</div>
                            <div className="text">{item.abstract}</div>
                          </div>
                        </div>
                      </div>
                      <div className="right">
                        <Button type="primary" onClick={this.goDetail.bind(this, item)}>详情</Button>
                      </div>
                    </li>
                  )
                }) : <Result title="暂无相关活动" />
              }
            </ul> */}
            <Row style={{margin: "20px 0"}} justify="end">
              {
                listData.length > 0 && <Pagination
                  showSizeChanger
                  showTotal={() => `合计： ${totalCount} 条 `}
                  onChange={this.changePage}
                  onShowSizeChange={this.onShowSizeChange}
                  defaultCurrent={page}
                  total={totalCount}
                  pageSize={limit}
                />
              }
            </Row>
          </div>
        </div>
      </div>
    )
  }
}

export default ExamIndex;
